import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as InvitationsActions from './invitations.actions';
import { Invitation } from '@fantaz/shared/data-access/models';

export const INVITATIONS_FEATURE_KEY = 'invitations';

export interface State extends EntityState<Invitation> {
  total?: number;
  selectedId?: string | number; // which Invitations record has been selected
  loaded: boolean; // has the Invitations list been loaded
  error?: string | null; // last known error (if any)
}

export interface InvitationsPartialState {
  readonly [INVITATIONS_FEATURE_KEY]: State;
}

export const invitationsAdapter: EntityAdapter<Invitation> =
  createEntityAdapter<Invitation>({
    selectId: (invitation: Invitation) => invitation.uuid,
  });

export const initialState: State = invitationsAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const invitationsReducer = createReducer(
  initialState,
  on(InvitationsActions.init, (state) => ({
    ...state,
    total: 0,
    loaded: false,
    error: null,
  })),
  on(InvitationsActions.loadInvitationsSuccess, (state, { invites, total }) =>
    invitationsAdapter.setAll(invites, { ...state, loaded: true, total }),
  ),
  on(InvitationsActions.loadInvitationsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return invitationsReducer(state, action);
}
